import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative bg-gradient-to-b from-blue-50 to-white pt-6 pb-16 md:pt-12 md:pb-24 overflow-hidden" data-id="element-68">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-70">
          <div className="inline-block bg-blue-100 text-blue-800 px-4 py-1.5 rounded-full text-sm font-bold mb-8 tracking-wide uppercase shadow-sm" data-id="element-71">
            Para Docentes de Inglés
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight mb-6" data-id="element-72">
            PACK INGLÉS <span className="text-blue-600" data-id="element-73">LISTO™</span>
          </h1>

          <p className="text-xl md:text-2xl text-gray-600 mb-6 font-medium leading-relaxed max-w-3xl mx-auto" data-id="element-74">
            El sistema que te devuelve el control del aula, el tiempo… y la
            tranquilidad.
          </p>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative max-w-sm mx-auto mb-4 group" data-id="element-75">
            <div className="absolute inset-0 bg-blue-400 rounded-full filter blur-[80px] opacity-20 transform translate-y-10 group-hover:opacity-30 transition-opacity duration-500" data-id="element-76"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5mG6wq3aQjG2VtzYwFTYSg/Diseno_sin_titulo.png" alt="Pack Inglés Listo - Material didáctico completo" className="relative w-3/4 h-auto mx-auto drop-shadow-2xl hover:scale-[1.02] transition-transform duration-500 cursor-pointer" onClick={() => {
            const purchaseSection = document.getElementById('purchase');
            if (purchaseSection) {
              purchaseSection.scrollIntoView({
                behavior: 'smooth'
              });
            }
          }} data-id="element-77" />
          </motion.div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-4" data-id="element-78">
            <CTAButton text="SÍ, QUIERO MI PACK AHORA" data-id="element-79" />
          </div>

          <p className="text-sm text-gray-500 font-medium" data-id="element-80">
            ⚡ Descarga inmediata · Acceso de por vida
          </p>
        </motion.div>
      </div>
    </section>;
}